import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chat-rooms"
export default class extends Controller {
  
  static targets = ["chat_inbox"];
  
  showConversation(event) {
    const id = event.currentTarget.dataset.id;
    const chatUrl = `/students/chat_rooms/${id}`;

    // Remove inline style from all elements with class "my-class"
    var contacts_list = document.querySelectorAll(".contacts-list");

    contacts_list.forEach((element) => {
      element.classList.remove("selected-chat");
    });
  
    //document.querySelector('.message-content').classList.remove("selected-chat");
    event.currentTarget.classList.add("selected-chat"); // Add CSS class to change background color
    fetch(chatUrl)
      .then((response) => response.text())
      .then((html) => {
        //window.scrollTo(0, 0);
        document.querySelector('#chat_room').innerHTML = html;
      });
  }
}
